const CGP_ERROR_CODES = {
    GENERAL_ERROR_SUPPORT: 100000,
    RESTRICTED_COUNTRY: 100105,
    INVALID_CREDENTIALS: 110,
    LOGIN_RESTRICTION: 100115,
    INVALID_REFRESH_TOKEN: 100120,
    CAPTCHA_REQUIRED: 170,
    TOUCH_ID_CHANGE_PASS: 100300,
    TOUCH_ID_EXPIRE: 100305,
    GENERAL_ERROR: 900000,
    OPENING_GAME_ERROR: 100205,
    UNSUPPORTED_ANONYMOUS: 100210,
    TIME_LIMIT_REACHED_DAILY: 100155,
    TIME_LIMIT_REACHED_WEEKLY: 100180,
    TIME_LIMIT_REACHED_MONTHLY: 100181,

    TOKEN_NOT_VALID: 20,
    PENDING_ACTION_REQUIRED: 50
};

export {CGP_ERROR_CODES};
